import { ApiService } from '@ligo/shared/utils';
import { RESOURCES } from '../resources';
import { Payment } from '@ligo/shared/auth';

export const PaymentService = {
  async createMolliePayment(uuid: string) {
    return ApiService.post<Payment>(`${RESOURCES.CREATE_MOLLIE_PAYMENT(uuid)}`);
  }
};
